import apiClient from '../api';

const AUTH_HEADER = 'Authorization';

export const setToken = (token, tokenType = 'Bearer') =>
  apiClient.setHeader(AUTH_HEADER, `${tokenType} ${token}`);

export const deleteToken = () => apiClient.setHeader(AUTH_HEADER, '');
